import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import classNames from "classnames";

class Uploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      percentCompleted: 0,
      resolution_acceptable: true,
      fileUploading: false,
      isSaving: false,
    };
    this.onSuccessCallback = this.onSuccessCallback.bind(this);
    this.failureCallBack = this.failureCallBack.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.saveSuccess = this.saveSuccess.bind(this);
  }

  componentDidMount() {
    const token = document.querySelector("[name=csrf-token]").content;
    axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
  }

  onSuccessCallback(result) {
    if (result.status === 200) {
      this.setState({ percentCompleted: 100, isSaving: true });

      console.log(result.data.eager[0].secure_url);

      const image = {
        width: result.data.width,
        height: result.data.height,
        filename: result.data.original_filename,
        external_id: result.data.public_id,
        host: "cloudinary",
        path: "path",
        source: "direct",
        url: result.data.secure_url,
        filesize: result.data.bytes,
        format: result.data.format,
        shopify_customer_id: this.props.shopify_customer_id,
      };

      console.log(image);

      if (result.data.coordinates != null) {
        image.cx = result.data.coordinates.custom[0][0];
        image.cy = result.data.coordinates.custom[0][1];
        image.cw = result.data.coordinates.custom[0][2];
        image.ch = result.data.coordinates.custom[0][3];
      }

      $.ajax({
        method: "POST",
        url: this.props.post_image_url,
        data: {
          image: image,
        },
      }).done(this.saveSuccess);
    }
  }

  saveSuccess(data) {
    this.setState({ fileUploading: false });
    if (data.resolution_acceptable) {
      this.setState({ resolution_acceptable: true });
      console.log(data.url);
      window.location.href = data.url;
    } else {
      this.setState({
        fileUploading: false,
        isSaving: false,
        resolution_acceptable: false,
        resolution_warning:
          "This image isn't a high enough resolution for us to print.",
      });
    }
  }

  uploadFile(files) {
    this.setState({ fileUploading: true, resolution_acceptable: true });

    const onUploadProgress = (event) => {
      const percentCompleted = Math.round((event.loaded * 100) / event.total);
      this.setState({ percentCompleted: percentCompleted });
    };

    const formData = new FormData();
    formData.append("file", files[0]);
    formData.append("upload_preset", "framefox_default");

    // First check file size
    if (files[0].size > 200000000) {
      this.setState({
        fileUploading: false,
        resolution_acceptable: false,
        resolution_warning:
          "This file is over 200 megabytes. Please upload a smaller image or get in touch and we can assist",
      });
      return;
    }

    // Check image dimensions
    const img = new Image();
    img.src = window.URL.createObjectURL(files[0]);
    img.onload = () => {
      const megapixels = (img.width * img.height) / 1000000;
      if (megapixels > 200) {
        this.setState({
          fileUploading: false,
          resolution_acceptable: false,
          resolution_warning:
            "This image is over 200 megapixels. Please upload an image with a smaller resolution.",
        });
        window.URL.revokeObjectURL(img.src);
        return;
      }

      // If all checks pass, proceed with upload
      axios
        .post("https://api.cloudinary.com/v1_1/framefox/upload", formData, {
          onUploadProgress,
        })
        .then((response) => {
          this.onSuccessCallback(response);
        })
        .catch((error) => {
          this.setState({
            fileUploading: false,
            resolution_acceptable: false,
            resolution_warning:
              "There was an error uploading your image. Please try again.",
          });
        })
        .finally(() => {
          window.URL.revokeObjectURL(img.src);
        });
    };

    img.onerror = () => {
      this.setState({
        fileUploading: false,
        resolution_acceptable: false,
        resolution_warning:
          "Unable to read image dimensions. Please try a different image.",
      });
      window.URL.revokeObjectURL(img.src);
    };
  }

  failureCallBack(event) {
    console.log(event.error);
  }

  renderBlankState() {
    return (
      <div className="alert alert-warning mt-4 py-3">
        <h4 className="text-xl">Whoops 😕</h4>
        <span>{this.state.resolution_warning}</span>
        <p className="text-muted small mt-1">
          Please feel free to{" "}
          <a href="/pages/contact" className="underline">
            contact us
          </a>{" "}
          if for assistance.
        </p>
      </div>
    );
  }

  render() {
    const { upload, crop_ratio } = this.props;

    return (
      <div
        className={classNames(
          this.state.fileUploading ? "bg-pale" : "bg-white",
          "text-center w-full p-4"
        )}
      >
        {!upload && !this.state.fileUploading && (
          <React.Fragment>
            <input
              className="hidden"
              type="file"
              id="upload-button"
              accept="image/*"
              onChange={(event) => this.uploadFile(event.target.files)}
            />
            <label
              className="
              py-3 px-7
              btn btn-primary btn-lg disabled:bg-stone-400 disabled:border-stone-400 disabled:text-white disabled:cursor-not-allowed
            "
              htmlFor="upload-button"
            >
              {this.state.fileUploading || this.state.isSaving ? (
                <i className="fa-solid fa-spinner fa-spin mr-2"></i>
              ) : (
                <i className="fa-solid text-sm fa-arrow-up-from-bracket mr-2" />
              )}
              {this.state.isSaving ? "Storing" : "Choose a file"}
            </label>
          </React.Fragment>
        )}

        {this.state.resolution_acceptable ? null : this.renderBlankState()}

        {this.state.fileUploading && (
          <div className="relative pt-1">
            <img
              src={this.props.preloader_icon}
              className="max-w-[100px] mx-auto"
            />
            <div className="flex mb-2 items-center justify-between">
              <div>
                {this.state.percentCompleted == 100 ? (
                  <span className="text-xs tracking-wide font-semibold inline-block pl-2 py-1 uppercase rounded-full text-yellow-600 ">
                    <span className="">
                      <UploadPreloader />
                    </span>{" "}
                    Finishing up
                  </span>
                ) : (
                  <span className="text-xs  tracking-wide font-semibold inline-block py-1 uppercase rounded-full text-brand-600 animate-pulse">
                    Uploading...
                  </span>
                )}
              </div>
              <div className="text-right">
                <span
                  className={classNames(
                    this.state.percentCompleted == 100
                      ? "text-yellow-600"
                      : "text-brand-600",
                    "text-xs font-semibold inline-block"
                  )}
                >
                  {this.state.percentCompleted}%
                </span>
              </div>
            </div>
            <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-white">
              <div
                style={{ width: `${this.state.percentCompleted}%` }}
                className={classNames(
                  this.state.percentCompleted == 100
                    ? "bg-yellow-600"
                    : "bg-brand-600",
                  "shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center "
                )}
              ></div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const UploadPreloader = (props) => (
  <svg
    className="inline animate-spin -ml-1 mr-1 h-4 w-4 text-yellow-600"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

export default Uploader;
